import { DefaultValues } from "react-hook-form";
import * as yup from "yup";

export const studioQrCodeSchema = yup
  .object({
    id: yup.number().default(0).defined(),
    name: yup
      .string()
      .trim()
      .required("Името е задължително")
      .max(200, "Името може да е най-много 200 символа")
      .defined(),
    destinationUrl: yup
      .string()
      .trim()
      .required("Дестинацията е задължителна")
      .max(2048, "Дестинацията е твърде дълга")
      .defined(),
    isActive: yup.boolean().default(true).defined(),
  })
  .required();

export type IStudioQrCodeFormModel = yup.InferType<typeof studioQrCodeSchema>;

export const studioQrCodeFormDefaultValues: DefaultValues<IStudioQrCodeFormModel> =
  {
    id: 0,
    name: "",
    destinationUrl: "",
    isActive: true,
  };
